import { isEmpty } from "lodash";

export const CTX_ACTIONS = {
  CTX_LIST_RQ: "CTX_LIST_RQ",
  CTX_LIST_OK: "CTX_LIST_OK",
  CTX_LIST_FAIL: "CTX_LIST_FAIL",

  CTX_UPDATE_LIST_RQ: "CTX_UPDATE_LIST_RQ",
  CTX_UPDATE_LIST_OK: "CTX_UPDATE_LIST_OK",
  CTX_UPDATE_LIST_FAIL: "CTX_UPDATE_LIST_FAIL",

  CTX_GET_RQ: "CTX_GET_RQ",
  CTX_GET_OK: "CTX_GET_OK",
  CTX_GET_FAIL: "CTX_GET_FAIL",

  CTX_ADD_RQ: "CTX_ADD_RQ",
  CTX_ADD_OK: "CTX_ADD_OK",
  CTX_ADD_FAIL: "CTX_ADD_FAIL",

  CTX_UPDATE_RQ: "CTX_UPDATE_RQ",
  CTX_UPDATE_OK: "CTX_UPDATE_OK",
  CTX_UPDATE_FAIL: "CTX_UPDATE_FAIL",

  CTX_DELETE_RQ: "CTX_DELETE_RQ",
  CTX_DELETE_OK: "CTX_DELETE_OK",
  CTX_DELETE_FAIL: "CTX_DELETE_FAIL",

  CTX_DUPLICATE_RQ: "CTX_DUPLICATE_RQ",
  CTX_DUPLICATE_OK: "CTX_DUPLICATE_OK",
  CTX_DUPLICATE_FAIL: "CTX_DUPLICATE_FAIL",

  CTX_RESET_ALL: "CTX_RESET_ALL",
};

export const contextI = {
  ctx_contexts: [],
  ctx_list_loading: false,
  ctx_update_list_loading: false,
  ctx_get_loading: false,
  ctx_add_loading: false,
  ctx_update_loading: false,
  ctx_delete_loading: false,
  ctx_duplicate_loading: false,
  ctx_error: null,
};

export const contextReducer = (state: any, action: any) => {
  switch (action.type) {
    case CTX_ACTIONS.CTX_LIST_RQ:
      return { ...state, ctx_list_loading: true, ctx_error: null };
    case CTX_ACTIONS.CTX_LIST_FAIL:
      return { ...state, ctx_list_loading: false };
    case CTX_ACTIONS.CTX_LIST_OK:
      return {
        ...state,
        ctx_list_loading: false,
        ctx_contexts: isEmpty(action.data) ? [] : action.data,
      };

    case CTX_ACTIONS.CTX_UPDATE_LIST_RQ:
      return { ...state, ctx_update_list_loading: true, ctx_error: null };
    case CTX_ACTIONS.CTX_UPDATE_LIST_FAIL:
      return { ...state, ctx_update_list_loading: false };
    case CTX_ACTIONS.CTX_UPDATE_LIST_OK:
      return {
        ...state,
        ctx_update_list_loading: false,
        ctx_contexts: [...state.ctx_contexts, ...action.data],
      };

    case CTX_ACTIONS.CTX_GET_RQ:
      return { ...state, ctx_get_loading: true, ctx_error: null };
    case CTX_ACTIONS.CTX_GET_FAIL:
      return { ...state, ctx_get_loading: false };
    case CTX_ACTIONS.CTX_GET_OK:
      return { ...state, ctx_get_loading: false };

    case CTX_ACTIONS.CTX_ADD_RQ:
      return { ...state, ctx_add_loading: true, ctx_error: null };
    case CTX_ACTIONS.CTX_ADD_FAIL:
      return { ...state, ctx_add_loading: false };
    case CTX_ACTIONS.CTX_ADD_OK:
      return {
        ...state,
        ctx_add_loading: false,
        ctx_contexts: isEmpty(action.data)
          ? [...state.ctx_contexts]
          : [action.data, ...state.ctx_contexts],
      };

    case CTX_ACTIONS.CTX_DUPLICATE_RQ:
      return { ...state, ctx_duplicate_loading: true, ctx_error: null };
    case CTX_ACTIONS.CTX_DUPLICATE_FAIL:
      return { ...state, ctx_duplicate_loading: false };
    case CTX_ACTIONS.CTX_DUPLICATE_OK:
      return {
        ...state,
        ctx_duplicate_loading: false,
        ctx_contexts: isEmpty(action.data)
          ? [...state.ctx_contexts]
          : [...action.data, ...state.ctx_contexts],
      };

    case CTX_ACTIONS.CTX_UPDATE_RQ:
      return { ...state, ctx_update_loading: true, ctx_error: null };
    case CTX_ACTIONS.CTX_UPDATE_FAIL:
      return { ...state, ctx_update_loading: false };
    case CTX_ACTIONS.CTX_UPDATE_OK:
      if (isEmpty(action.data)) {
        return;
      }
      return {
        ...state,
        ctx_update_loading: false,
        ctx_contexts: state.ctx_contexts.map((item: any) =>
          item.id === action.data.id ? action?.data : item,
        ),
      };

    case CTX_ACTIONS.CTX_DELETE_RQ:
      return { ...state, ctx_delete_loading: true, ctx_error: null };
    case CTX_ACTIONS.CTX_DELETE_FAIL:
      return { ...state, ctx_delete_loading: false };
    case CTX_ACTIONS.CTX_DELETE_OK:
      return {
        ...state,
        ctx_delete_loading: false,
        ctx_contexts: state.ctx_contexts.filter((item: any) => !action.data.includes(item.id)),
      };

    case CTX_ACTIONS.CTX_RESET_ALL:
      return {
        ...state,
        ctx_contexts: [],
        ctx_list_loading: false,
        ctx_update_list_loading: false,
        ctx_get_loading: false,
        ctx_add_loading: false,
        ctx_update_loading: false,
        ctx_delete_loading: false,
        ctx_duplicate_loading: false,
        ctx_error: null,
      };
    default:
      return state;
  }
};
